import { Button, Spinner } from '@heroui/react'
import { Download } from 'lucide-react'
import { useState } from 'react'

export default function DownloadHistoryButton({ generation, voiceName }) {
  const [isDownloading, setIsDownloading] = useState(false)

  const handleDownload = async () => {
    if (!generation.audioDataURL)
      return

    setIsDownloading(true)

    try {
      // Fetch the blob to download
      const response = await fetch(generation.audioDataURL)
      const blob = await response.blob()

      // Generate filename with timestamp
      const timestamp = new Date(generation.timestamp)
        .toISOString()
        .replace(/[:.]/g, '-')
        .split('T')[0]
      const filename = `${voiceName || 'voice'}_${timestamp}_generation.wav`

      // Create download using data URL
      const reader = new FileReader()
      reader.onload = function (e) {
        const dataUrl = e.target.result
        const link = document.createElement('a')
        link.href = dataUrl
        link.download = filename
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        setIsDownloading(false)
      }
      reader.readAsDataURL(blob)
    }
    catch (error) {
      console.error('Failed to download audio:', error)
      setIsDownloading(false)
    }
  }

  return (
    <Button
      variant="light"
      isIconOnly
      disableRipple
      size="sm"
      color="secondary"
      onPress={handleDownload}
      className="min-w-0"
      isDisabled={!generation.audioDataURL}
      spinner={<Spinner size="sm" variant="spinner" classNames={{ spinnerBars: 'bg-default-500' }} />}
      isLoading={isDownloading}
    >
      {!isDownloading && <Download size={16} />}
    </Button>
  )
}
